// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2wMqb","title":"AfterFrontImage_title__2t9Lf"};